<ng-template #text>
  <span *ngIf="state === AsyncActionState.IDLE" role="status">{{ displayMessage }}</span>
  <span *ngIf="state === AsyncActionState.ACTIVE" class="text-info" role="status">{{ loadingMessage }}</span>
  <span *ngIf="state === AsyncActionState.ERROR"  class="text-danger" role="status">{{ errorMessage }}</span>
  <span *ngIf="state === AsyncActionState.COMPLETE" class="text-success" role="status">{{ successMessage }}</span>
</ng-template>
<ng-template #initialButton>
  <button type="button" class="lazy-button" (click)="onLinkClick($event)">
    <ng-container *ngTemplateOutlet="text" ></ng-container>
  </button>
</ng-template>
<ng-template #completeAnchor>
  <a #anchor [href]="resolvedUrl" [target]="target">
    <ng-container *ngTemplateOutlet="text" ></ng-container>
  </a>
</ng-template>
<ng-container *ngIf="state === AsyncActionState.COMPLETE; then completeAnchor; else initialButton"></ng-container>
<svg xmlns="http://www.w3.org/2000/svg" *ngIf="showIcon" class="icon ml-1" viewBox="0 0 16 16">
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
</svg>
